import fetchApi from './config'

export const getRoles = async () => {
  return await fetchApi('/roles')
}
